import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'fgb-menu-toggle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu-toggle.component.html',
  styleUrl: './menu-toggle.component.scss',
})
export class MenuToggleComponent {
  @Input() isActive = false;
  @Input() size = 40;
  @Input() strokeWidth = 7;
  @Output() onToggleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggle() {
    this.isActive = !this.isActive;
    this.onToggleChange.emit(this.isActive);
  }

  get styles() {
    return {
      'stroke-width': this.strokeWidth + 'px',
    };
  }
}
